import { getInclusionsWithoutPackageValidityText } from 'components/OfferPage/Accommodation/packageInclusionValidityUtils'

interface PackageWithInclusions {
  inclusions?: Array<App.PackageInclusion>
  bonusInclusions?: Array<App.PackageInclusion>
}

// Empty when there's nothing to show, including when the only inclusion is manually-authored validity copy (e.g. "Inclusions valid for one adult").
export function getUpgradableInclusions(
  packages: Array<PackageWithInclusions>,
  displayedInclusions: Array<{ description: string }>,
): Array<App.PackageInclusion> {
  if (!packages.length) return []

  const packageWithMostInclusions = packages.reduce((max, pkg) => {
    const maxCount = (max.inclusions?.length ?? 0) + (max.bonusInclusions?.length ?? 0)
    const pkgCount = (pkg.inclusions?.length ?? 0) + (pkg.bonusInclusions?.length ?? 0)
    return pkgCount > maxCount ? pkg : max
  }, packages[0])

  const mostInclusions = [
    ...(packageWithMostInclusions.inclusions ?? []),
    ...(packageWithMostInclusions.bonusInclusions ?? []),
  ]
  if (!mostInclusions.length) return []

  const displayedDescriptions = new Set(displayedInclusions.map(inclusion => inclusion.description))
  const seenDescriptions = new Set<string>()

  const upgradableInclusions = mostInclusions.filter(inclusion => {
    const desc = inclusion.description
    if (displayedDescriptions.has(desc) || seenDescriptions.has(desc)) return false
    seenDescriptions.add(desc)
    return true
  })

  // Strips validity-only fragments (whole entries or just the "Inclusions valid for..." part of a combined "real - validity" description) to tell whether anything real is left.
  const realUpgradableInclusions = getInclusionsWithoutPackageValidityText(upgradableInclusions, true)

  if (!realUpgradableInclusions.length) return []

  if (
    realUpgradableInclusions.length === 1 &&
    realUpgradableInclusions[0].description.toLowerCase().includes('breakfast')
  ) {
    return []
  }

  return upgradableInclusions
}
